import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { trans } from '../../localization/language';

class NavBar extends React.Component {
	render() {
		return (
			<div className="hd-nav">
				<div className="hd-nav-inner">
					<div className="hd-nav__item">
						<Link to="/" className={(this.props.routing.locationBeforeTransitions.pathname === "/") ? "hd-nav__link hd-nav__link--cur" : "hd-nav__link"} >
							{trans('home')}
						</Link>
					</div>
					<div className="hd-nav__item">
						<Link to="/security" className={this.props.routing.locationBeforeTransitions.pathname.startsWith("/security") ? "hd-nav__link hd-nav__link--cur" : "hd-nav__link"} >
							{trans('security')}
						</Link>
					</div>
					<div className="hd-nav__item">
						<Link to="/faq" className={this.props.routing.locationBeforeTransitions.pathname.startsWith("/faq") ? "hd-nav__link hd-nav__link--cur" : "hd-nav__link"} >
							FAQ
						</Link>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		routing: state.routing
	}
}

export default connect(mapStateToProps)(NavBar);


// WEBPACK FOOTER //
// ./app/components/header/NavBar.js